import {
  MdAssessment,
  MdBalance,
  MdCheckCircle,
  MdPeople,
  MdSchedule,
  MdStar,
} from "react-icons/md";
import StatCard from "components/stat-card";
import { getArchetype } from "lib/archetypes";
import { EMPTY, formatNumber } from "utils/format";

const withSuffix = (val, suffix) => (val != null ? `${formatNumber(val)}${suffix}` : EMPTY);

const AssessmentMetrics = ({ metrics, config }) => {
  if (!metrics) return null;

  const { labels } = config;
  const tiles = [
    {
      key: "assessmentsCompleted",
      label: "Assessments Completed",
      icon: MdAssessment,
      value: formatNumber(metrics.assessmentsCompleted),
    },
    {
      key: "activeStaff",
      label: `Active ${labels.plural}`,
      icon: MdPeople,
      value: formatNumber(metrics.activeStaff),
    },
    {
      key: "mostCommonArchetype",
      label: "Most Common Archetype",
      icon: MdStar,
      accent: "gold",
      value:
        getArchetype(metrics.mostCommonArchetype)?.label || metrics.mostCommonArchetype || EMPTY,
    },
    {
      key: "completionRate",
      label: "Completion Rate",
      icon: MdCheckCircle,
      value: withSuffix(metrics.completionRate, "%"),
    },
    {
      key: "balanceScore",
      label: "Balance Score",
      icon: MdBalance,
      value: withSuffix(metrics.balanceScore, "/100"),
    },
    {
      key: "daysSinceLast",
      label: "Days Since Last",
      icon: MdSchedule,
      accent: "neutral",
      value: withSuffix(metrics.daysSinceLast, metrics.daysSinceLast === 1 ? " day" : " days"),
    },
  ];

  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {tiles.map(({ key, label, icon, accent = "sage", value }) => (
        <StatCard key={key} icon={icon} accent={accent} label={label} value={value} />
      ))}
    </div>
  );
};

export default AssessmentMetrics;
